import { createFileRoute } from '@tanstack/react-router';

import NotFound from '~/app/404';
import { getRouteHead } from '~/app/routeHead';

export const Route = createFileRoute('/404')({
  component: NotFound,
  head: () => getRouteHead({ title: '404: Not found' }),
});
